import React from "react";

export default function NoAccess({ message }) {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      padding: "40px 20px",
      textAlign: "center",
    }}>
      <div style={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 20,
      }}>
        <svg width="24" height="24" fill="none" stroke="#57534E" strokeWidth="2" viewBox="0 0 24 24">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0110 0v4"/>
        </svg>
      </div>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: "#111827", margin: "0 0 8px" }}>
        Ingen atkomst
      </h2>
      <p style={{ fontSize: 14, color: "#6b7280", maxWidth: 360, lineHeight: 1.6 }}>
        {message || "Du har inte behorighet att se denna sida. Kontakta din administrator for att fa atkomst."}
      </p>
    </div>
  );
}
